import React from 'react';
import styled from 'styled-components';
import Theme from 'Theme';
import { zoomIn } from '../Animations';

export const Input = styled.input`
  display: none;
`;

export const Contain = styled.div`
  margin-right: 4px;
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 0.8em;
  justify-content: flex-start;
  cursor: pointer;
`;

export const Check = ({ checked }) => {
  return (
    <CheckContain checked={checked}>
      {checked && <CheckIcon color={Theme.primaryColor} />}
    </CheckContain>
  );
};

const CheckContain = styled.div`
  height: 18px;
  width: 18px;
  display: flex;
  border-radius: 9999px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
`;

export const CheckIcon = styled.div`
  cursor: pointer;
  user-select: none;
  position: relative;
  width: 14px;
  height: 14px;
  border-radius: 999px;
  background-color: ${props => props.theme.brandColor};
  ${zoomIn}
`;

export const RadioDisplay = styled.div`
  height: 18px;
  width: 18px;
  opacity: 1;
  display: flex;
  cursor: pointer;
  user-select: none;
  border-width: 2px;
  border-radius: 9999px;
  border-color: ${props => props.checked ? props.theme.brandColor : Theme.lightMediumGrey};
  background-color: #fff;
  border-style: solid;
  align-items: center;
  background-color: #fff;
  justify-content: center;
  will-change: transform, opacity, border-color, background-color;
  transition: all 0.2s ease;

  &:active {
    opacity: 0.8;
    transform: scale(0.9, 0.9);
    border-color: ${props => props.theme.brandColor};
  }

  &:hover {
    opacity: 0.5;
    border-color: ${props => props.theme.brandColor};
  }
`;

export const Label = styled.div`
  margin-left: 16px;
`;
